class SizeTableToggle extends HTMLElement {
  connectedCallback() {
    this.template = this.querySelector('template');
    this.controller = this.querySelector('button');

    if (!this.controller) return;

    const drawerId = this.controller.getAttribute('aria-controls');
    this.drawer = drawerId ? document.getElementById(drawerId) : null;
    this.drawerContainer = this.drawer?.querySelector('[data-size-table-content-container]');

    this.controller.addEventListener('click', () => this.updateDrawerContent());
  }

  updateDrawerContent() {
    if (!this.template || !this.drawerContainer) return;
    this.drawerContainer.innerHTML = this.template.innerHTML;
  }
}

customElements.define('size-table-toggle', SizeTableToggle);
